import { ReactNode } from "react";
import { useScrollActivate } from "../hooks/useScrollActivate";

type ScrollObservedPreviewProps = {
  onActivate: () => void;
  enabled?: boolean;
  children: ReactNode;
};

export const ScrollObservedPreview = ({
  onActivate,
  enabled,
  children,
}: ScrollObservedPreviewProps) => {
  const setTarget = useScrollActivate(onActivate, enabled);
  return <div ref={setTarget}>{children}</div>;
};
